import React, {useEffect, useRef} from "react"
import styled from "styled-components"

import {H2, Body} from "@irati/ui/src/Typography"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import Button from "@irati/ui/src/Button"
import tracking from "@irati-tracking/recognition/recognition"

import {InjectIntlProps} from "@irati/utils/lang/injectIntl"
import Spacing from "@irati/ui/src/Spacing"
import theme from "@irati/ui/src/global/theme"
import recogniseSuccessReward from "../../../images/scheduled-reward.svg"

const Image = styled.img`
  height: 100px;
  margin-bottom: 15px;
  width: auto;
`
interface Props extends InjectIntlProps {
  onClickButton: () => void
  onHide: () => void
  timeoutMilliseconds?: number
}
const SuccessScheduled: React.FC<Props> = (props) => {
  const {formatMessage, onClickButton, onHide, timeoutMilliseconds = 30000} = props
  const closeSuccessTimeout = useRef(-1)
  useEffect(() => {
    tracking.recognitionConfirmation({type: "scheduled", source: "reward"})
    closeSuccessTimeout.current = setTimeout(onHide, timeoutMilliseconds)
    return () => {
      clearTimeout(closeSuccessTimeout.current)
    }
  }, [])
  return (
    <div className="text-center">
      <Image alt={formatMessage({id: "recognition.popup.createRecognition.success.image"})} src={recogniseSuccessReward} />
      <H2>
        <FormattedMessage id="platform.recognition.scheduledReward.success.header" />
      </H2>
      <Spacing marginBottom={theme.spacing.two} marginTop={theme.spacing.one}>
        <Body large maxWidth="100%" marginBottom={1} textAlign="center">
          <FormattedMessage id="platform.recognition.scheduledReward.success.body" />
        </Body>
      </Spacing>
      <Button primary large full onClick={onClickButton}>
        <FormattedMessage id="recognition.popup.createRecognition.success.rewardAgainButton" />
      </Button>
    </div>
  )
}

export default injectIntl(SuccessScheduled)
